var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-layout',{staticStyle:{"z-index":"900"},attrs:{"view":"hhh lpr fff"}},[_c('HeaderWebComponent'),_c('q-page-container',[_c('router-view')],1),_c('FooterWebComponent'),_c('FarmaciaPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }